import React from 'react';
import { transitions, positions, Provider as AlertProvider } from 'react-alert';
import AlertTemplate from '../components/AlertTemplate';
import { Provider as BusProvider } from 'react-bus';

const options = {
  position: positions.BOTTOM_CENTER,
  timeout: 5000,
  offset: '30px',
  transition: transitions.SCALE,
};

const DjinnProvider: React.FC = ({ children }) => {
  return (
    <BusProvider>
      <AlertProvider template={AlertTemplate} {...options}>
        {children}
        <div id="confirm-delete-popup" />
      </AlertProvider>
    </BusProvider>
  );
};

export default DjinnProvider;
